<script lang="ts">
import { ComplaintInfo } from '@/interface/Complaint.interface';
import Flight from './steps/flight.vue';
import Passenger from './steps/passenger.vue';
import Topic from './steps/topic.vue';
import { TicketChannel } from '@/interface/TicketChannel.interface';
import { ticketChannelService } from '@/services/serviceProvider';

export default {
    components: {
        Flight,
        Passenger,
        Topic
    },
    setup() {
        return {}
    },
    props: {
        modelValue: {
            type: Object,
            default: {},
        },
    },
    emits: [
        'update:modelValue',
    ],
    data() {
        return {
            model: this.modelValue as ComplaintInfo,
            channels: [] as TicketChannel[],
            flightStepNo: undefined as number | undefined,
            passengerStepNo: undefined as number | undefined,
            complaintStepNo: undefined as number | undefined,
            lang: this.$i18n.locale,
        }
    },
    watch: {
        '$i18n.locale': function (newVal, oldVal) {
            this.lang = newVal;
        }
    },
    computed: {
        haveFlightStep(): boolean {
            const step1 = this.model?.form?.stepOne;
            return step1 && step1.length > 0 || false;
        },
        havePassengerStep(): boolean {
            const step2 = this.model?.form?.stepTwo;
            return (step2 && step2.length > 0) || false;
        },
        haveComplaintStep(): boolean {
            const step3 = this.model?.form?.stepThree;
            return step3 && step3.length > 0 || false;
        },
    },
    async mounted() {
        await this.getChannels();
        this.initStepNo();
    },
    methods: {
        async getChannels() {
            try {
                let res = await ticketChannelService.getAllMainTicketChannels();
                if (res && res.status == 200) {
                    this.channels = res.data as TicketChannel[];
                }
            } catch (e) {
                throw (e);
            }
        },
        initStepNo() {
            let stepNo = 1;
            if (this.haveFlightStep) {
                this.flightStepNo = stepNo;
                stepNo++;
            }
            if (this.havePassengerStep) {
                this.passengerStepNo = stepNo;
                stepNo++;
            }
            if (this.haveComplaintStep) {
                this.complaintStepNo = stepNo;
            }
        },
        ticketChannel(): string {
            return this.model.flight
                ? ticketChannelService.ticketChannelString(this.model.flight.channel, this.lang)
                : '';
        },
    },
};
</script>
<template>
    <div class="request-splitter d-flex align-center my-5 ml-2">
        <div style="min-width: fit-content;" class="mr-2">{{ $t('t-complaint-data-from-request') }}</div>
        <v-divider class="mr-2"></v-divider>
    </div>
    <div v-if="haveFlightStep" class="request-step-section d-flex-align-center mb-4 mx-2">
        <v-avatar size="x-small" class="mr-2 active">
            <span>{{ flightStepNo }}</span>
        </v-avatar>
        {{ $t('t-complaint-flight-information') }}
    </div>
    <v-card v-if="haveFlightStep" class="app-card px-0 pb-0">
        <div class="schedule-info align-center my-2 mx-6" style="gap: 18px;">
            <div class="d-flex">
                <span class="label mr-2">{{ $t('t-flight-number') }}</span>
                <span>{{ model.flight?.flightNo }}</span>
            </div>
            <div class="splitter" style="height: inherit;"></div>
            <div class="d-flex">
                <span class="label mr-2">{{ $t('t-flight-date-fly') }}</span>
                <span>{{ model.flight?.departureDateString }}</span>
            </div>
            <div class="splitter"></div>
            <div class="d-flex">
                <span class="label mr-2">{{ $t('t-complaint-ticket-channel') }}</span>
                <span v-if="channels">{{ ticketChannel() }}</span>
            </div>
        </div>
        <v-divider class="mx-6"></v-divider>
        <!-- <v-card-text class="pb-0 pt-6 px-6"> -->
        <Flight ref="flight" v-if="model" v-model="model" :view-mode="true" :summary-info="true"></Flight>
        <!-- </v-card-text> -->
    </v-card>
    <div v-if="havePassengerStep" class="request-step-section d-flex-align-center mb-4 mx-2">
        <v-avatar size="x-small" class="mr-2 active">
            <span>{{ passengerStepNo }}</span>
        </v-avatar>
        {{ $t('t-complaint-passenger-information') }}
    </div>
    <Passenger ref="passenger" v-if="model && havePassengerStep" v-model="model" :view-mode="true"></Passenger>
    <div v-if="haveComplaintStep" class="request-step-section d-flex-align-center mb-4 mx-2">
        <v-avatar size="x-small" class="mr-2 active">
            <span>{{ complaintStepNo }}</span>
        </v-avatar>
        {{ $t('t-complaint-topic') }}
    </div>
    <Topic ref="topic" v-if="model && haveComplaintStep" v-model="model" :view-mode="true" :show-title="false"
        :summary-complaint="true">
    </Topic>
    <div style="height: 35px;"></div>
</template>